import { useRef } from "react";
import { useInView } from "@/lib/motion";

export const Reveal = ({ as: Tag = "div", className = "", children, threshold = 0.15, delay = 0, ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { threshold });
  return (
    <Tag ref={ref} className={`${className} ${inView ? "is-in" : ""}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};

export const SplitLines = ({ lines, as: Tag = "h2", className = "", stagger = 110, baseDelay = 0, ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { threshold: 0.2 });
  return (
    <Tag ref={ref} className={`${className} ${inView ? "is-in" : ""}`} {...rest}>
      {lines.map((l, i) => (
        <span className="rl-line" key={i}>
          <span style={{ transitionDelay: `${baseDelay + i * stagger}ms` }}>{l}{" "}</span>
        </span>
      ))}
    </Tag>
  );
};
